





























































































































































































































































































































































































































































































































































































































import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import InfoCard from "@/components/InfoCard.vue";
import AskProfile from "@/modals/AskProfile.vue";
import AddWorkExp from "@/modals/AddWorkExp.vue";
import AddEducation from "@/modals/AddEducation.vue";
import PickOccupations from "@/modals/PickOccupations.vue";
import Success from "@/modals/Success.vue";
import Error from "@/modals/Error.vue";
import profile from "@/interfaces/profile";
import attachment from "@/interfaces/attachment";
import attachmentManager from "@/helpers/AttachmentManager";
import languageSkill from "@/interfaces/languageSkill";
import { format, parseISO } from "date-fns";
import _ from "lodash";

export default Vue.extend({
	components: {
		InfoCard,
		AskProfile,
		AddWorkExp,
		AddEducation,
		PickOccupations,
      Success,
		Error
	},
	data() {
		return {
			worker: {} as any,
			aml: [] as any,
			profiles: [] as any,
			selectedProfile: {} as profile,
			languageSkills: [] as languageSkill[],
			saveAvailable: true,
			isLoading: true as boolean,
			editData: null as any,
			editDataEdu: null as any,
			langSkillOptions: [
				{ text: this.$t("native-language"), value: 7 },
				{ text: "C2", value: 6 },
				{ text: "C1", value: 5 },
				{ text: "B2", value: 4 },
				{ text: "B1", value: 3 },
				{ text: "A2", value: 2 },
				{ text: "A1", value: 1 },
			],
			selectableLangs: [] as any[],
         langText: [] as any,
			selectableDrivingLicenses: [] as any[],
			selectableOccupationClasses: [] as any[],
         selectableProfessionsTree: [] as any[],
         selectedProfessionIds: [] as any,
         occupationSearchText: "",
         showAllOccupations: false as boolean,
         hideOccupationCheckboxList: false as boolean,
			carOptions: [
				{ text: this.$t("yes"), value: true },
				{ text: this.$t("no"), value: false },
				{ text: this.$t("unknown"), value: undefined },
			],
			cvfiles: [],
			uploadProgress: 0,
			//alla liitteiden uploadaamisessa liitteen kuvaus ja nimi.
			//jatkossa käyttöön ehkä, toistaiseksi ei. displayname kannassa sama kuin alkup. tiedostonimi
			description: "",
			displayName: "",
         //Input validation info array
         inputValidations: [
            {name: "osaamisenKuvaus", text: ""},
            {name: "kielitaidonKuvaus", text: ""},
            {name: "harrastukset", text: ""},
            {name: "lisatiedot", text: ""},
            {name: "itOsaamisenKuvaus", text: ""},
			],
         preSetDrivinglicences: [],
         preSetLanguageSkills: [] as any,
         //Headai taito-/avainsanojen hakuun liittyvät:
         keywords: [] as any,
         deletedKeywords: [] as any,
         currentSkills: [] as any,
         deletedSkills: [] as any,
         unDeletedSkills: [] as any,
         skillsAddedByClerk: [] as any,
         textFromFields: "",
         loadingKeywords: false,         
         newKeywordsData: [] as any,
         autocompleteSkillWords: "",
         autoCompleteData: [] as any,
         savingKeywordsInProgress: false,
         //Headai taito-/avainsanojen hakuun liittyvät päättyy
         showAllIctSkills: false as boolean,
         ictSkillsSearchText:"",
         hideIctSkillsCheckboxList: false as boolean,
         selectableIctSkills: [] as any[],
			selectedIctIds: [] as any,
         preventSaveError: false as boolean, 
         preSetIctSkills: [],
         saveErrors: [] as any
      }
	},
	computed: {
      isMobile() {
         return store.state.isMobile;
      }, 
		storeAuthObject() {
			return this.$store.state.strongAuth;
		},
		storeJwt() {
			return this.$store.state.jwt;
		},
		workerdata() {
			return this.$data.worker;
		},
		profileNameComp() {
			if (this.$data.selectedProfile)
				return this.$data.selectedProfile.profiilinimi;
			else return this.$t("create-profile");
		},
		currentProfile() {
			return this.$data.selectedProfile;
		},
		expEditData() {
			return this.$data.editData;
		},
		eduEditData() {
			return this.$data.editDataEdu;
		},
		isPhone() {
			return window.innerWidth < 800 ? true : false;
		},
      headaiEnabled() {
			return this.$store.state.orgServices.includes("headai");
		},
      headaiJobsEnabled() {
			return this.$store.state.orgServices.includes("työpaikkasuositukset");
		}
	},
	methods: {
		getWorkerData() {			
         axios.get("Itsepalvelu/user").then((resp) => {
				this.worker = resp.data;
				// axios.get(`Itsepalvelu/user/aml/${resp.data.uid}`).then(r => {
				//     this.worker.ammattiluokitukset = r.data;            
				axios.get("Profile/profiles")
            .then((response) => {
					response.data.forEach((pr: any) => {
						if (pr.perusprofiili) {
							this.selectedProfile = pr;
							this.languageSkills = pr.kielitaidot;
						}
						pr.tyokokemukset.forEach((tk:any) => {
							if(tk.alkupvm)tk.alkupvm = parseISO(tk.alkupvm)
							if(tk.loppupvm)tk.loppupvm = parseISO(tk.loppupvm)
						})
					});
					if (response.data.length < 1) {
						axios
							.post(`Profile/profile`, {
								tyonhakijaId: this.worker.uid,
								perusprofiili: true,
								profiilinimi: "Perusprofiili",
							} as profile)
							.then(() => {
								axios.get("Profile/profiles").then((response) => {
									response.data.forEach((pr: any) => {
										if (pr.perusprofiili) this.selectedProfile = pr;
										this.profiles.push(pr);
									});
								}).catch((error) => {
                           if (error.response) {
                              console.log(error.response.status);                  
                           } else if (error.request) {
                              console.log('no response');
                           } else {                  
                              console.log('Error');
                           }
                        });                        
							});
					} else this.profiles = response.data;

               if(this.headaiEnabled){
                  this.getSkillWords();
               }
               if(this.selectedProfile.perusprofiili==true){                  
                  this.preSetEmptyFieldsFromJobseekerData();
               }
               for(var i = 0; i < this.selectedProfile.hakuammattialat.length; i++){
                  var pId = this.selectedProfile.hakuammattialat[i].uid;                  
                  this.selectedProfessionIds.push(pId);
               }
               for(i = 0; i < this.selectedProfile.itTaidot.length; i++){
                  var ictId = this.selectedProfile.itTaidot[i].uid;                  
                  this.selectedIctIds.push(ictId);
               }

               for(i = 0; i < this.selectedProfile.kielitaidot.length; i++){
                  // Kaikilla kielillä ei välttämättä kielistyksia, niin defaulttina suomi
                  switch (this.$store.state.lang) {
                     case 'fi':
                        this.langText.push(this.selectedProfile.kielitaidot[i].nimi.toString());;
                        break;
                     case 'en':
                        if(!this.isNullUndefinedEmpty(this.selectedProfile.kielitaidot[i].nimiEnglanti)){
                           this.langText.push(this.selectedProfile.kielitaidot[i].nimiEnglanti.toString());
                        }else{
                           this.langText.push(this.selectedProfile.kielitaidot[i].nimi.toString());
                        }
                        break;
                     case 'se':
                        if(!this.isNullUndefinedEmpty(this.selectedProfile.kielitaidot[i].nimiRuotsi)){
                           this.langText.push(this.selectedProfile.kielitaidot[i].nimiRuotsi.toString());
                        }else{
                           this.langText.push(this.selectedProfile.kielitaidot[i].nimi.toString());
                        }
                        break;
                     default:
                        this.langText.push(this.selectedProfile.kielitaidot[i].nimi.toString());
                        break;
					   }  
                  // this.langText.push(this.selectedProfile.kielitaidot[i].nimi.toString());
               }

				}).catch((error) => {
               if (error.response) {
                  console.log(error.response.status);                  
               } else if (error.request) {
                  console.log('no response');
               } else {                  
                  console.log('Error');
               }              
            });

				// })
			});
         
		},


      getSkillWords(){

         if(this.worker !== null && this.worker !== undefined && this.selectedProfile !== undefined && this.selectedProfile !== null){
            if(this.selectedProfile.uid !== undefined){
               axios.get(`keywords/keywords/${this.selectedProfile.uid}/${true}`).then((r) => {
                  this.keywords = r.data;
                  this.keywords = this.keywords.sort((a: any,b: any) => a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1);
                  for (var i = 0; i < this.keywords.length;i++){
                     if(this.keywords[i].itsepalvelustaLisatty == false || this.keywords[i].itsepalvelustaLisatty == null){
                        this.skillsAddedByClerk.push(this.keywords[i].concept);
                     } else if(this.keywords[i].itsepalvelustaLisatty == true){
                        this.currentSkills.push(this.keywords[i].concept);
                     }
                  }		
               });
               axios.get(`keywords/deletedkeywords/${this.selectedProfile.uid}/${true}`).then((r) => {
                  this.deletedKeywords = r.data;
                  this.deletedKeywords = this.deletedKeywords.sort((a: any,b: any) => a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1);
                  for (var i = 0; i < this.deletedKeywords.length;i++){
                     this.deletedSkills.push(this.deletedKeywords[i].concept);
                  }	
               });               
            }
         }
      
      },

		// get all organization selectable fields
		getSelectables() {
			axios.get(`Itsepalvelu/aml`).then((resp) => {
				this.aml = resp.data;
			});
         //Kielivalikko
         let emptyOption = {
            text: (this.$t('choose-language')),
            value: {
               kieliId: null,
               "nimi": (this.$t('choose-language')),
               profiiliId: null,
               taitotaso: null
            }
         };
         this.selectableLangs.push(emptyOption);
         axios.get(`Profile/languages`).then((resp) => {
				resp.data.forEach((language: any) => {    
               let option: any = {};
               switch (this.$store.state.lang) {
						case 'fi':
							option = {
								text: language.nimi,
								value: language,
							};
							break;
						case 'en': 
							option = {
								text: !this.isNullUndefinedEmpty(language.nimiEnglanti) ? language.nimiEnglanti : language.nimi,
								value: language,
							};
							break;
						case 'se':
							option = {
								text: !this.isNullUndefinedEmpty(language.nimiRuotsi) ? language.nimiRuotsi : language.nimi,
								value: language,
							};
							break;
						default:
							option = {
								text: language.nimi,
								value: language,
							};
							break;
					}                        
					this.selectableLangs.push(option);
				});
			});
         //
			axios.get(`Profile/drivinglicenses`).then((resp) => {
				resp.data.forEach((x: any) => {
					let option;					
               option = {
						textFI: x.nimi,
                  textSE: !this.isNullUndefinedEmpty(x.nimiRuotsi) ? x.nimiRuotsi : x.nimi,
                  textEN: !this.isNullUndefinedEmpty(x.nimiEnglanti) ? x.nimiEnglanti : x.nimi,
						value: x,
					};
					this.selectableDrivingLicenses.push(option);               
				});
			});
			axios
				.get("Profile/occupationclasses")
				.then((resp) => {
               this.selectableProfessionsTree = resp.data;
               this.selectableProfessionsTree = this.selectableProfessionsTree.sort((a1,a2) => a1.aakkosrakenne < a2.aakkosrakenne ? -1 : 1);
					resp.data.forEach((row: any) => {
						if (row.paaNro == 0) {
							let occupationclass = {} as any;
							occupationclass.value = { ...row };
							switch (store.state.lang) {
								case 'fi':
									occupationclass.text = row.nimi;
									break;
								case 'en':
									if(row.nimiEnglanti) {
										occupationclass.text = row.nimiEnglanti;
									}
									else occupationclass.text = row.nimi;
									break;
								case 'se':
									if(row.nimiRuotsi) {
										occupationclass.text = row.nimiRuotsi;
									}
									else occupationclass.text = row.nimi;
									break;
								default:
									occupationclass.text = row.nimi;
									break;
							}
							occupationclass.alat = [];
							this.selectableOccupationClasses.push(occupationclass);
						}
					});
					resp.data.forEach((row: any) => {
						if (row.paaNro != 0) {
							this.selectableOccupationClasses.forEach((x) => {
								if (x.value.uid == row.paaNro) {
									let pObj = {} as any;
									pObj.value = row;
									switch (store.state.lang) {
										case 'fi':
											pObj.text = row.nimi;
											break;
										case 'en':
											pObj.text = row.nimiEnglanti;
											break;
										case 'se':
											pObj.text = row.nimiRuotsi;
											break;
										default:
											pObj.text = row.nimi;
											break;
									}									
									x.alat.push(pObj);
								}
							});
						}
					});

			});
			axios
			.get("Profile/ictskills")
			.then((resp) => {
				this.selectableIctSkills = resp.data;
				this.selectableIctSkills = this.selectableIctSkills.sort((a1,a2) => a1.jarjestys < a2.jarjestys ? -1 : 1);			
			})
			.finally(() => {
				this.isLoading = false;
			});			
		},
		profTranslate(prof :any) {
			switch (store.state.lang) {
				case 'fi':
					return prof.nimi
				case 'en':
					if(prof.nimiEnglanti) {
						return prof.nimiEnglanti
					}
					return prof.nimi
				case 'se':
					if(prof.nimiRuotsi) {
						return prof.nimiRuotsi
					}
					return prof.nimi
				default:
					return prof.nimi
			}
		},
      ictTranslate(ict :any) {
			switch (store.state.lang) {
				case 'fi':
					return ict.nimi
				case 'en':
					if(ict.nimiEnglanti) {
						return ict.nimiEnglanti
					}
					return ict.nimi
				case 'se':
					if(ict.nimiRuotsi) {
						return ict.nimiRuotsi
					}
					return ict.nimi
				default:
					return ict.nimi
			}
		},
		getProfiles() {
			axios.get("Profile/profiles").then((response) => {
				this.profiles = response.data;
			});
		},
		askNewProfile() {
			this.$bvModal.show("ask-profile");
		},
		selectProfile(profile: any) {
			this.selectedProfile = profile;
			this.languageSkills = profile.kielitaidot;
		},
		saveProfile() {

			this.saveAvailable = false;
			axios
				.put("profile/saveprofile", this.selectedProfile)
				.then((x) => {
					this.saveAvailable = true;
					console.log(x);
				}).catch((error) => {
               if (error.response) {
                  console.log(error.response.status);                  
               } else if (error.request) {
                  console.log('no response');
               } else {                  
                  console.log('Error');
               }              
               this.saveErrors.push({failed: "profile"});
            })
				//toimii, mutta description ja displayname placeholderina vielä.
				.then(() => {
					if (this.cvfiles.length > 0) {
						const formData = new FormData();
						let data = JSON.stringify({
							description: this.description,
							displayName: this.displayName,
						});
						for (let i = 0; i < this.cvfiles.length; i++) {
							formData.append("files", this.cvfiles[i]);
							formData.append("data", data);
							formData.append("profileId", this.currentProfile.uid);
						}
						axios
							.post("Attachments/save", formData, {
								headers: {
									"Content-Type": "multipart/form-data",
								},
								onUploadProgress: (progressEvent) => {
									console.log(progressEvent.loaded + "/" + progressEvent.total);
									this.uploadProgress = Math.round(
										(parseInt(progressEvent.loaded) /
											parseInt(progressEvent.total)) *
											100
									);
								},
							})
							.catch((er) => {
								console.log(er);
                        this.saveErrors.push({failed: "attachments"});
							})
							.then(() => {
								setTimeout(() => {
									this.uploadProgress = 0;
								}, 2);
							});
					}					
				}).finally(() => {
               //reloads page
               //this.$router.go(0);
               if(this.headaiEnabled){
                  //returns false if error
                  this.saveKeywords(false).then((data) => {
                     if(data===false){                        
                        this.saveErrors.push({failed: "keywords"});
                     }
                     if(this.saveErrors.length===0){
                        this.showSuccess();
                     } else {
                        this.showError();
                     }
                  });
                     
               } else {
                  if(this.saveErrors.length===0){
                     this.showSuccess();
                  } else {
                     this.showError();
                  }
               }            

            });

         
		},
		firstCharToUpper(s: string) {
			return _.upperFirst(s);
		},
		addNewLangSkill() {
			let tempLang = {
				kieliId: null,
            taitotaso: null,
            profiiliId: this.currentProfile.uid,
				nimi: this.$t("choose-language"),
			};     
			this.selectedProfile.kielitaidot.push(tempLang);
         this.langText.push(this.$t("choose-language"));

		},
		addWorkExp() {
			this.$bvModal.show("add-work-exp");
		},
		editWorkExp(exp: any) {
			this.editData = exp;
			this.$bvModal.show("add-work-exp");
		},
		addEducation() {
			this.$bvModal.show("add-education");
		},
		editEducation(edu: any) {
			this.editDataEdu = edu;
			this.$bvModal.show("add-education");
		},
		clearEditData() {
			this.editData = null;
			this.editDataEdu = null;
		},
		addOccupations() {
			this.$bvModal.show("pick-occupations");
		},
		dateDisplay(d: string|Date): string {
			if (typeof(d) == "string") {
				return format(parseISO(d), "d.M.Y");
			}
			else {
				return format(d, "d.M.Y");
			}
		},
		removeAla(ala: any) {
			this.selectedProfile.hakuammattialat =
				this.selectedProfile.hakuammattialat.filter(function (value: any) {
					return value.uid != ala.uid;
				});
         var indexToRemove = this.selectedProfessionIds.indexOf(ala.uid);
         this.selectedProfessionIds.splice(indexToRemove, 1);
         
		},
		updateAlat(alat: any) {
			this.selectedProfile.hakuammattialat = alat;
		},
		confirmExpRemoval(exp: any) {
			this.$bvModal
				.msgBoxConfirm(this.$t("delete") + ' ' + this.$t("work-exp").toString().toLowerCase() + '?' as string, {
					size: "sm",
					buttonSize: "sm",
					okVariant: "danger",
					okTitle: this.$t("yes") as string,
					cancelTitle: this.$t("no") as string,
					centered: true,
					hideHeaderClose: false,
					footerClass: "p-2",
				})
				.then((val) => {
					if (val === true) {
						this.selectedProfile.tyokokemukset?.splice(
							_.indexOf(this.selectedProfile.tyokokemukset, exp),
							1
						);
						this.clearEditData();
						this.$bvModal.hide("add-work-exp");
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		confirmEduRemoval(edu: any) {
			this.$bvModal
				.msgBoxConfirm(this.$t("are-you-sure") as string, {
					size: "sm",
					buttonSize: "sm",
					okVariant: "danger",
					okTitle: this.$t("yes") as string,
					cancelTitle: this.$t("no") as string,
					centered: true,
					hideHeaderClose: false,
					footerClass: "p-2",
				})
				.then((val) => {
					if (val === true) {
						this.selectedProfile.koulutukset?.splice(
							_.indexOf(this.selectedProfile.koulutukset, edu),
							1
						);
						this.clearEditData();
						this.$bvModal.hide("add-education");
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		removeLanguage(index: number) {
			this.selectedProfile.kielitaidot.splice(index, 1);
		},
		makeAttachmentDownloadLink(attachment: attachment) {
			return attachmentManager.makeAttachmentDownloadLink(attachment);
		},
		downloadAttachment(attachment: attachment) {
			axios({
				method: "get",
				url: this.makeAttachmentDownloadLink(attachment),
				responseType: "blob",
			}).then((r) => {
				const url = window.URL.createObjectURL(new Blob([r.data]));
				const link = document.createElement("a");
				link.href = url;
				link.download = attachment.originalFilename;
				document.body.appendChild(link);
				link.click();
			});
		},
		confirmAttachmentRemoval(attachment: attachment) {
			this.$bvModal
				.msgBoxConfirm(this.$t("are-you-sure") as string, {
					size: "sm",
					buttonSize: "sm",
					okVariant: "danger",
					okTitle: this.$t("yes") as string,
					cancelTitle: this.$t("no") as string,
					centered: true,
					hideHeaderClose: false,
					footerClass: "p-2",
				})
				.then((val) => {
					if (val === true) {
						this.selectedProfile.liitteet?.splice(
							_.indexOf(this.selectedProfile.liitteet, attachment),
							1
						);
						axios.delete(`attachments/remove/${attachment.uid}`).then((r) => {
							console.log(r);
						});
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},


      async collectTextFromFields(){
         this.textFromFields = "";
         
         var i;

         this.addTF(this.selectedProfile.osaamisenKuvaus);
         this.addTF(this.selectedProfile.kielitaidonKuvaus);
         this.addTF(this.selectedProfile.harrastukset);
         this.addTF(this.selectedProfile.lisatiedot);
         this.addTF(this.selectedProfile.itOsaamisenKuvaus);
         
         var tyokokemus = "";
         if(!(this.selectedProfile.tyokokemukset==undefined)){
            if(this.selectedProfile.tyokokemukset.length>0){
               for(i = 0; i < this.selectedProfile.tyokokemukset.length; i++){
                  if(tyokokemus+""!==""){tyokokemus = tyokokemus + " "}
                  tyokokemus = tyokokemus + this.selectedProfile.tyokokemukset[i].nimike;
                  if(tyokokemus+""!==""){tyokokemus = tyokokemus + " "}
                  tyokokemus = tyokokemus + this.selectedProfile.tyokokemukset[i].kuvaus;                   
               }
            }
         }
         this.addTF(tyokokemus);

         var koulutus = "";
         if(!(this.selectedProfile.koulutukset==undefined)){
            if(this.selectedProfile.koulutukset.length>0){
               for(i = 0; i < this.selectedProfile.koulutukset.length; i++){
                  if(koulutus+""!==""){koulutus = koulutus + " "}
                  koulutus = koulutus + this.selectedProfile.koulutukset[i].nimike;                  
               }
            }
         }
         this.addTF(koulutus);

         var kielitaidot = "";
         if(!(this.selectedProfile.kielitaidot==undefined)){
            if(this.selectedProfile.kielitaidot.length>0){
               for(i = 0; i < this.selectedProfile.kielitaidot.length; i++){
                  if(kielitaidot+""!==""){kielitaidot = kielitaidot + " "}
                  if(this.$store.state.lang.toLowerCase()==="en"){
                     kielitaidot = kielitaidot + this.selectedProfile.kielitaidot[i].nimiEnglanti;
                  } else if (this.$store.state.lang.toLowerCase()==="se") {
                     kielitaidot = kielitaidot + this.selectedProfile.kielitaidot[i].nimiRuotsi;
                  } else {
                     kielitaidot = kielitaidot + this.selectedProfile.kielitaidot[i].nimi;
                  }
               }
            }
         }
         this.addTF(kielitaidot);

         var hakuammattialat = "";
         if(!(this.selectedProfile.hakuammattialat==undefined)){
            if(this.selectedProfile.hakuammattialat.length>0){               
               for(i = 0; i < this.selectedProfile.hakuammattialat.length; i++){
                  if(hakuammattialat+""!==""){hakuammattialat = hakuammattialat + " "}                  
                  if(this.$store.state.lang.toLowerCase()==="en"){
                     hakuammattialat = hakuammattialat + this.selectedProfile.hakuammattialat[i].nimiEnglanti;
                  } else if (this.$store.state.lang.toLowerCase()==="se") {                     
                     hakuammattialat = hakuammattialat + this.selectedProfile.hakuammattialat[i].nimiRuotsi;
                  } else {
                     hakuammattialat = hakuammattialat + this.selectedProfile.hakuammattialat[i].nimi;
                  }
               }
            }
         }
         this.addTF(hakuammattialat);

         var itOsaamiset = "";
         if(!(this.selectedProfile.itTaidot==undefined)){
            if(this.selectedProfile.itTaidot.length>0){               
               for(i = 0; i < this.selectedProfile.itTaidot.length; i++){
                  if(itOsaamiset+""!==""){itOsaamiset = itOsaamiset + " "}                  
                  if(this.$store.state.lang.toLowerCase()==="en"){
                     itOsaamiset = itOsaamiset + this.selectedProfile.itTaidot[i].nimiEnglanti;
                  } else if (this.$store.state.lang.toLowerCase()==="se") {                     
                     itOsaamiset = itOsaamiset + this.selectedProfile.itTaidot[i].nimiRuotsi;
                  } else {
                     itOsaamiset = itOsaamiset + this.selectedProfile.itTaidot[i].nimi;
                  }                 
               }
            }
         }         
         this.addTF(itOsaamiset);

         this.textFromFields = this.textFromFields.replace(/[\r\n]+/g," ");
			return "done.";
      },
      
      addTF(newText: any){         
         if(newText !== null && newText !== undefined && newText+"" !== ""){
            if(this.textFromFields+"" !== ""){
               this.textFromFields = this.textFromFields + " ";
            }
            this.textFromFields = this.textFromFields + newText;
         }
      },

		async getCvText() {			
			try {							
				let filesFormData = new FormData();
				if(this.cvfiles.length > 0) {
					for (let i = 0; i < this.cvfiles.length; i++) {
						filesFormData.append("files", this.cvfiles[i]);
					}
				}
				let cvText = await axios.post(`keywords/cvtotext/${this.selectedProfile.uid}`,
					filesFormData,
						{
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					}	
				).then(r => {            
					//console.log('success');
					return r.data.text;										
				})        
				.catch(function(){
					console.log('fail');
					return "";
				});				
				return cvText;
			}
			catch (err) {
				console.error(err);
				return "";
			}
		},

      generateSkillWords(){
         this.collectTextFromFields().then(() => {            
				console.log("text collected from fields");				
			}).catch(() => {
				console.log("failed to collect text");
			}).then(() => {			
				let cvText = "";
				this.getCvText().then(r => {            
					cvText = r;
					this.addTF(cvText);
					console.log('text collected from cv');
				}).catch(() => {
					console.log("failed to read CV");
				}).then(()=>{
    				this.newKeywordsData = [];
         		this.loadingKeywords = true;
					let formData = new FormData();
					formData.append("text", this.textFromFields.toString() || '');
					formData.append("language", this.currLangForHA());
					if(this.textFromFields+""=="" || this.textFromFields == null){
						this.loadingKeywords = false;
					} else {
						axios.post("keywords/textToKeywords",
							formData,
							{						
								headers: {
								'Content-Type': 'multipart/form-data'
								},
							}
						).then(response => {
							this.newKeywordsData = response.data.sort((a: any,b: any) => a.displayname.toLowerCase() < b.displayname.toLowerCase() ? -1 : 1);
							this.loadingKeywords = false;
						})
						.catch(function(){
							console.log('Error receiving keywords!');
						});   
					}
				});				
			});		
      },

      removeKeyword(keyword: any){
         
         var skillIndex;
         if(this.currentSkills.includes(keyword.concept)){
            skillIndex = this.currentSkills.indexOf(keyword.concept);
            this.currentSkills.splice(skillIndex, 1);

            let indexToRemove;
            indexToRemove = this.keywords.findIndex((x: any) => x.concept === keyword.concept)
            if (indexToRemove !== undefined){this.keywords.splice(indexToRemove, 1);}

         }

         if(this.unDeletedSkills.includes(keyword.concept)){
            skillIndex = this.unDeletedSkills.indexOf(keyword.concept);
            this.unDeletedSkills.splice(skillIndex, 1);
         }

         if(!(this.deletedSkills.includes(keyword.concept))){                  
               this.deletedSkills.push(keyword.concept);

               const skillToDelete = {
                  tyonhakijaId: this.worker.uid, 
                  profiiliId: this.selectedProfile.uid,
                  concept: keyword.concept, 
                  displayName: keyword.displayName,
                  count: keyword.count,
                  weight: keyword.weight,
                  relevancy: keyword.relevancy,
                  language: keyword.language,
                  rawData: keyword.rawData
               }
               
               this.deletedKeywords.push(skillToDelete);

         }
            
      },

      addKeyword(skill: any, src: string){
         var skillIndex;

         if(this.deletedSkills.includes(skill.concept)){
            skillIndex = this.deletedSkills.indexOf(skill.concept);
            this.deletedSkills.splice(skillIndex, 1);

            let indexToRemove;
            indexToRemove = this.deletedKeywords.findIndex((x: any) => x.concept === skill.concept)
            if (indexToRemove !== undefined){this.deletedKeywords.splice(indexToRemove, 1);}

            this.unDeletedSkills.push(skill.concept);
         }

         if(!(this.currentSkills.includes(skill.concept))){
            this.currentSkills.push(skill.concept);

            //src: "new", "addedByClerk" tai "abandoned"
            if(src.toLowerCase()=="new"){

               const addedSkill = {                  
                  tyonhakijaId: this.worker.uid, 
                  profiiliId: this.selectedProfile.uid,
                  concept: skill.concept, 
                  displayName: skill.displayname,
                  count: skill.count,
                  weight: skill.weight,
                  relevancy: skill.relevancy,
                  language: skill.language,
                  rawData: JSON.stringify(skill),
                  itsepalvelustaLisatty: true
               }

               this.keywords.push(addedSkill);



            } else {

               if(this.skillsAddedByClerk.includes(skill.concept)){
                  skillIndex = this.skillsAddedByClerk.indexOf(skill.concept);
                  this.skillsAddedByClerk.splice(skillIndex, 1);

                  let indexToRemove;
                  indexToRemove = this.keywords.findIndex((x: any) => x.concept === skill.concept)
                  if (indexToRemove !== undefined){this.keywords.splice(indexToRemove, 1);}
               }

               const addedSkill = {
                  tyonhakijaId: this.worker.uid,
                  profiiliId: this.selectedProfile.uid,
                  concept: skill.concept, 
                  displayName: skill.displayName,
                  count: skill.count,
                  weight: skill.weight,
                  relevancy: skill.relevancy,
                  language: skill.language,
                  rawData: skill.rawData,
                  itsepalvelustaLisatty: true
               }

               this.keywords.push(addedSkill);               
            }
         }

         if(src.toLowerCase()=="new"){
            let indexToRemove;
            indexToRemove = this.newKeywordsData.findIndex((x: any) => x.concept === skill.concept)
            if (indexToRemove !== undefined){this.newKeywordsData.splice(indexToRemove, 1);}
         }        

      },

      addAutocompleteKeyword(word: string){
         var skillIndex;
         
         if(this.deletedSkills.includes(word)){
            skillIndex = this.deletedSkills.indexOf(word);
            this.deletedSkills.splice(skillIndex, 1);

            let indexToRemove;
            indexToRemove = this.deletedKeywords.findIndex((x: any) => x.concept === word)
            if (indexToRemove !== undefined){this.deletedKeywords.splice(indexToRemove, 1);}

            this.unDeletedSkills.push(word);
         }

         if(!(this.currentSkills.includes(word))){
            
            var dpName = word.charAt(0).toUpperCase() + word.slice(1);
            
            this.currentSkills.push(word);

            const addedSkill = {                  
               tyonhakijaId: this.worker.uid, 
               profiiliId: this.selectedProfile.uid,
               concept: word, 
               displayName: dpName,
               count: 0,
               weight: 0,
               relevancy: 0,
               language: "fi",
               rawData: "",
               itsepalvelustaLisatty: true
            }

            this.keywords.push(addedSkill);

         }


      },

      async saveKeywords(reloadPageAfterSave: boolean): Promise<boolean>{
         this.savingKeywordsInProgress=true;
         
         var success = false;

         var deletedSkillsCount = this.deletedKeywords.length;
         var skillsCount = this.keywords.length;

         let formData = new FormData();

         formData.append("jobseekerId", (this.worker.uid+'').toString() || '');
         formData.append("profileId", (this.selectedProfile.uid+'').toString() || '');         
         formData.append("deletedSkillsCount", deletedSkillsCount.toString() || 0);
         formData.append("skillsCount", skillsCount.toString() || 0);
         
			var i;
			for (i = 0; i < skillsCount;i++){			
				formData.append("skill"+i+"_concept", this.keywords[i].concept || '');
            formData.append("skill"+i+"_displayname", this.keywords[i].displayName || '');
            formData.append("skill"+i+"_count", this.keywords[i].count || 0);
            formData.append("skill"+i+"_weight", this.keywords[i].weight || 0);
            formData.append("skill"+i+"_relevancy", this.keywords[i].relevancy || 0);
            formData.append("skill"+i+"_language", this.keywords[i].language || '');
            formData.append("skill"+i+"_rawdata", this.keywords[i].rawData || '');
            if(this.keywords[i].itsepalvelustaLisatty==true){
               formData.append("skill"+i+"_selfserviceadded", "true");
            } else {
               formData.append("skill"+i+"_selfserviceadded", "false");
            }
			}

			for (i = 0; i < deletedSkillsCount;i++){			
				formData.append("deletedskill"+i+"_concept", this.deletedKeywords[i].concept || '');
            formData.append("deletedskill"+i+"_displayname", this.deletedKeywords[i].displayName || '');
            formData.append("deletedskill"+i+"_count", this.deletedKeywords[i].count || 0);
            formData.append("deletedskill"+i+"_weight", this.deletedKeywords[i].weight || 0);
            formData.append("deletedskill"+i+"_relevancy", this.deletedKeywords[i].relevancy || 0);
            formData.append("deletedskill"+i+"_language", this.deletedKeywords[i].language || '');
            formData.append("deletedskill"+i+"_rawdata", this.deletedKeywords[i].rawData || '');
			}
         
         await axios.post("keywords/saveKeywords",
            formData,
            {						
               headers: {
                  'Content-Type': 'multipart/form-data'
               },
            }
         ).then(response => {
            console.log(response.data);
            this.savingKeywordsInProgress=false;
            if(reloadPageAfterSave===true){
               this.$router.go(0);
            }
            success = true;
         }).catch((error) => {
            if (error.response) {
               console.log(error.response.status);                  
            } else if (error.request) {
               console.log('no response');
            } else {                  
               console.log('Error');
            }              
            //this.saveErrors.push({failed: "keywords"});
            success = false;
         });

        return success;


      },

      preSetEmptyFieldsFromJobseekerData(){
         if(this.selectedProfile.osaamisenKuvaus==null || this.selectedProfile.osaamisenKuvaus+""=="" || this.selectedProfile.osaamisenKuvaus == undefined){
            this.selectedProfile.osaamisenKuvaus = this.worker.itsepalveluOsaamisenKuvaus;
         }
         if(this.selectedProfile.harrastukset==null || this.selectedProfile.harrastukset+""=="" || this.selectedProfile.harrastukset == undefined){
            this.selectedProfile.harrastukset = this.worker.harrastukset;
         }
         if(this.selectedProfile.kielitaidonKuvaus==null || this.selectedProfile.kielitaidonKuvaus+""=="" || this.selectedProfile.kielitaidonKuvaus == undefined){
            this.selectedProfile.kielitaidonKuvaus = this.worker.kielitaito;
         }
         if(this.selectedProfile.itOsaamisenKuvaus==null || this.selectedProfile.itOsaamisenKuvaus+""=="" || this.selectedProfile.itOsaamisenKuvaus == undefined){
            this.selectedProfile.itOsaamisenKuvaus = this.worker.atkTaidot;
         }
         if(this.selectedProfile.omaAuto==null || this.selectedProfile.omaAuto+""=="" || this.selectedProfile.omaAuto == undefined){
            //alert(this.worker.omaAuto);
            if(parseInt(this.worker.omaAuto)==1){
               this.selectedProfile.omaAuto = true;
            } else if (parseInt(this.worker.omaAuto)==0){
               this.selectedProfile.omaAuto = false;
            }
         }

         if(this.selectedProfile.kielitaidot==null || this.selectedProfile.kielitaidot == undefined || this.selectedProfile.kielitaidot.length==0){
            //haetaan työnhakijan kortilta kielitaidot:
            axios.get(`Profile/preSetLanguageSkills/${this.worker.uid}`).then((r) => {
               this.preSetLanguageSkills = r.data;
               var len = this.preSetLanguageSkills.length;
               for(var l = 0;l<len;l++){
                  var langId = this.preSetLanguageSkills[l].kieliId;
                  var skillLevel = this.preSetLanguageSkills[l].taitotaso;                  
                  var languageSkill = this.selectableLangs.filter((qObj)=>{return qObj.value.kieliId === langId;}).pop();                  
                  var languageSkillToProfile = {
                     kieliId: langId,
                     nimi: languageSkill.value.nimi,
                     profiiliId: this.selectedProfile.uid,
                     taitotaso: skillLevel
                  }
                  this.selectedProfile.kielitaidot.push(languageSkillToProfile);
                  this.languageSkills = this.selectedProfile.kielitaidot;  
               }
            });
         }
         if(this.selectedProfile.ajokorttiLuokat==null || this.selectedProfile.ajokorttiLuokat == undefined || this.selectedProfile.ajokorttiLuokat.length==0){
            //haetaan työnhakijan kortilta ajokorttiluokat:
            axios.get(`Profile/preSetDrivinglicences/${this.worker.uid}`).then((r) => {
               this.preSetDrivinglicences = r.data;    
               var len = this.preSetDrivinglicences.length;
               for(var a = 0; a < len;a++){
                  var id = this.preSetDrivinglicences[a];                  
                  var drivingLicenceClass = this.selectableDrivingLicenses.filter((qObj)=>{return qObj.value.uid === id;}).pop();                  
                  this.selectedProfile.ajokorttiLuokat.push(drivingLicenceClass.value);                  
               }
            });
         }
         if(this.selectedProfile.itTaidot==null || this.selectedProfile.itTaidot == undefined || this.selectedProfile.itTaidot.length==0){
            //haetaan työnhakijan kortilta ittaidot:
            axios.get(`Profile/preSetIctSkills/${this.worker.uid}`).then((r) => {
               this.preSetIctSkills = r.data;    
               var len = this.preSetIctSkills.length;
               for(var i = 0; i < len;i++){
                  var id = this.preSetIctSkills[i];                  
                  var ictSkill = this.selectableIctSkills.filter((qObj)=>{return qObj.uid === id;}).pop();                  
                  this.selectedProfile.itTaidot.push(ictSkill);                  
                  this.selectedIctIds.push(ictSkill.uid);   

                  
               }
            });
         }
      },

      checkMaxLength: function(event: any, maxLength: any, inputValidationName: any){
         var el = event.currentTarget;
         if(!(el==undefined)){
            var len = el.value.length;             
            el.value = el.value.substring(0, (parseInt(maxLength)));            
            if(inputValidationName !== undefined && !(inputValidationName == null) && inputValidationName !== ""){
               for (var x = 0; x < this.inputValidations.length; x++){
                  if(this.inputValidations[x].name == inputValidationName){
                     if(parseInt(len) > parseInt(maxLength)){
                        this.inputValidations[x].text = "Maksimi merkkimäärä: " + maxLength + ".";
                     } else {
                        this.inputValidations[x].text = "";
                     }
                  }
               }                                     
            }                                                
         }
      },

      getValidationText: function(name: string){
         
         if(name !== undefined && !(name == null) && name !== ""){
            for (var x = 0; x < this.inputValidations.length; x++){
               if(this.inputValidations[x].name == name){
                  return this.inputValidations[x].text;
               }
            }                                     
         }      
         
      },

      addRemoveProfession: function(e: any, profession: any){
         if(e !== undefined){
            //alert(profession.uid + ": " + e);            
            if(e==true){
                var professionExists = this.selectedProfile.hakuammattialat.filter((qObj)=>{return qObj.uid === profession.uid;}).pop();
                if(professionExists==null || professionExists==undefined){
                   this.selectedProfile.hakuammattialat.push(profession);
                }
               
               var indx = this.selectedProfessionIds.indexOf(profession.uid);
               if(indx===-1){
                  this.selectedProfessionIds.push(profession.uid);
               }

            } else if (e==false){
               var indexToRemove = this.selectedProfile.hakuammattialat.findIndex((x: any) => x.uid === profession.uid)
               if (indexToRemove !== undefined){this.selectedProfile.hakuammattialat.splice(indexToRemove, 1);}
               
               var indxToRemove = this.selectedProfessionIds.indexOf(profession.uid);
               this.selectedProfessionIds.splice(indxToRemove, 1);
            }
         }         
      },

      toggleShowAllOccupations(){
         if(this.showAllOccupations==true){
            this.showAllOccupations=false;                
         } else if (this.showAllOccupations==false) {
            this.showAllOccupations=true;
            this.occupationSearchText="";
            this.showOccupationDropdownDiv();  
         }         
      },

      showOccupationDropdownDiv(){
         this.hideOccupationCheckboxList = false;         
      },
      hideOccupationDropdownDiv(){
         this.hideOccupationCheckboxList = true;         
      },
      toggleShowAllIctSkills(){
         if(this.showAllIctSkills==true){
            this.showAllIctSkills=false;                
         } else if (this.showAllIctSkills==false) {
            this.showAllIctSkills=true;
            this.ictSkillsSearchText="";
            this.showIctSkillsDropdownDiv();  
         }         
      },

      showIctSkillsDropdownDiv(){
         this.hideIctSkillsCheckboxList = false;         
      },
      hideIctSkillsDropdownDiv(){
         this.hideIctSkillsCheckboxList = true;         
      },      
      addRemoveIctSkill: function(e: any, ictskill: any){
         if(e !== undefined){           
            if(e==true){
                if(this.selectedProfile.itTaidot!==undefined){ 
						var ictSkillExists = this.selectedProfile.itTaidot.filter((qObj)=>{return qObj.uid === ictskill.uid;}).pop();                
						if(ictSkillExists==null || ictSkillExists==undefined){
							this.selectedProfile.itTaidot.push(ictskill);
						}
                  
                  var indx = this.selectedIctIds.indexOf(ictskill.uid);
                  if(indx===-1){
                     this.selectedIctIds.push(ictskill.uid);
                  }
 
					}					 
            } else if (e==false){
               if(this.selectedProfile.itTaidot!==undefined){ 
						var indexToRemove = this.selectedProfile.itTaidot.findIndex((x: any) => x.uid === ictskill.uid)
						if (indexToRemove !== undefined){this.selectedProfile.itTaidot.splice(indexToRemove, 1);}					
					}
               var indxToRemove = this.selectedIctIds.indexOf(ictskill.uid);
               this.selectedIctIds.splice(indxToRemove, 1);
            }
         }         
      },
		removeIctSkill(ictskill: any) {
			if(this.selectedProfile.itTaidot !== undefined){
			this.selectedProfile.itTaidot =
				this.selectedProfile.itTaidot.filter(function (value: any) {
					return value.uid != ictskill.uid;
				});
			}
         var indexToRemove = this.selectedIctIds.indexOf(ictskill.uid);
         this.selectedIctIds.splice(indexToRemove, 1);
		},

      addAllSkillWordsSuggestedBySystem(){
         var el: any
         var len = this.newKeywordsData.length;
         var n = 0;

         while (this.newKeywordsData.length) {
            if(!(this.newKeywordsData[0] == undefined)){
               el = this.$refs['KeywordBadge'+this.newKeywordsData[0].concept]; 
               if(!(el==undefined)){               
                  el[0].click();
               }            
            }
            n++;
            if(len===n){
               //pikkuvarmistus, ettei jää ikuista looppia, jos toi click-toiminto jostain syystä ei poistakaan sanaa arraysta
               break;
            }
         }
      },
      addAllSkillWordsSuggestedByClerk(){
         var el: any
         var len = this.skillsAddedByClerk.length;
         var n = 0;     
         while (this.skillsAddedByClerk.length) {
             if(!(this.skillsAddedByClerk[0] == undefined)){
               el = this.$refs['clerkAddedKeywordBadge'+this.skillsAddedByClerk[0].toString()]; 
               if(!(el==undefined)){
                  el[0].click();
               }            
            }
            n++;
            if(len===n){
               //pikkuvarmistus, ettei jää ikuista looppia, jos toi click-toiminto jostain syystä ei poistakaan sanaa arraysta
               break;
            }
         }
      },
      clickElementRef(elRef: any){
         var el: any;
         el = this.$refs[''+elRef.toString()]; 
         //alert(el[0].id);
         if(!(el==undefined)){   
            el[0].click();
         }        
      },
      languageAlreadySelected(langId: number){
         
         var langSelected = this.selectedProfile.kielitaidot.filter((qObj)=>{return qObj.kieliId === langId;}).pop();
         if(langSelected==null || langSelected==undefined){
            return false;
         } else {
            return true;
         }
         
      },
      languageTextInputUpdate(index: any, event: any){
         var langId = event.target.value;
         var langName = "";
         for(var i=0; i<this.selectableLangs.length;i++){
            if(this.selectableLangs[i].value.kieliId !== undefined){
               if(this.selectableLangs[i].value.kieliId==null){
                  if(langId=="" || langId == null){
                     switch (this.$store.state.lang) { // Näitä switch case helvettejä vois vähän selkiyttää, jos/kun kerkiää/jaksaa
                        case 'fi':
                           langName = this.selectableLangs[i].value.nimi;
                           break;
                        case 'en':
                           if(!this.isNullUndefinedEmpty(this.selectableLangs[i].value.nimiEnglanti)){
                              langName = this.selectableLangs[i].value.nimiEnglanti;
                           }else{
                              langName = this.selectableLangs[i].value.nimi;
                           }
                           break;
                        case 'se':
                           if(!this.isNullUndefinedEmpty(this.selectableLangs[i].value.nimiRuotsi)){
                              langName = this.selectableLangs[i].value.nimiRuotsi;
                           }else{
                              langName = this.selectableLangs[i].value.nimi;
                           }
                           break;
                        default:
                           langName = this.selectableLangs[i].value.nimi;
                           break;
                     }  
                     break;
                  }
               }                           
               if(parseInt(this.selectableLangs[i].value.kieliId)===parseInt(langId)){                  
                  switch (this.$store.state.lang) {
                     case 'fi':
                        langName = this.selectableLangs[i].value.nimi;
                        break;
                     case 'en':
                        if(!this.isNullUndefinedEmpty(this.selectableLangs[i].value.nimiEnglanti)){
                           langName = this.selectableLangs[i].value.nimiEnglanti;
                        }else{
                           langName = this.selectableLangs[i].value.nimi;
                        }
                        break;
                     case 'se':
                        if(!this.isNullUndefinedEmpty(this.selectableLangs[i].value.nimiRuotsi)){
                           langName = this.selectableLangs[i].value.nimiRuotsi;
                        }else{
                           langName = this.selectableLangs[i].value.nimi;
                        }
                        break;
                     default:
                        langName = this.selectableLangs[i].value.nimi;
                        break;
                  }  
               }              
            } 
         }         
         this.langText[index]=langName;
         
         //focus efekti:
         var el: any;
         el = this.$refs['langText'+index.toString()];          
         if(!(el==undefined)){   
            el[0].focus();
         }        
      },
      isNullUndefinedEmpty(val: any){
         if(val === null || val === '' || val === undefined){
            return true;
         }
         return false;
      },
      goHome(){
         this.$router.push({name: 'Itsepalvelu', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
      },
      showSuccess(){
			this.$bvModal.show("success-modal");
		},
		showError(){
			this.$bvModal.show("error-modal");
		},
      getCurrLangDrivingLicense(dl: any){
         var drivingLicence;
         switch (this.$store.state.lang) {
            case 'fi':
               drivingLicence = dl.value.nimi;
               break;
            case 'en':
               drivingLicence = dl.value.nimiEnglanti;
               break;
            case 'se':
               drivingLicence = dl.value.nimiRuotsi;
               break;         
         }
         if(this.isNullUndefinedEmpty(drivingLicence)){
            drivingLicence = dl.value.nimi;
         }
         return drivingLicence;
      },
      currLangForHA(){
         if(this.$store.state.lang.toLowerCase() === "en"){
            return "en";
         } else if (this.$store.state.lang.toLowerCase() === "se"){
            return "sv";
         } else {
            return "fi";
         }
      }
   },

   directives: {
      'click-outside': {
          inserted: (el: any, binding, vnode: any) => {
         // assign event to the element
            el.clickOutsideEvent = function (event: any) {
               // here we check if the click event is outside the element and it's children               
               if (!(el == event.target || el.contains(event.target))) {
               // if clicked outside, call the provided method
               vnode.context[binding.expression](event)
               }
            }
         // register click and touch events
            document.body.addEventListener('click', el.clickOutsideEvent)
            document.body.addEventListener('touchstart', el.clickOutsideEvent)
         },
         unbind: function (el: any) {
         // unregister click and touch events before the element is unmounted
            document.body.removeEventListener('click', el.clickOutsideEvent)
            document.body.removeEventListener('touchstart', el.clickOutsideEvent)
         }
      }
   },

	created() {
		this.getWorkerData();      
		this.getSelectables();
	},

	watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
						console.log(resp);
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
      autocompleteSkillWords(){
         if(this.autocompleteSkillWords.length>=2){            
            
            var langCode = "fi";
            if(this.$store.state.lang.toLowerCase() === "en"){
               langCode = "en"
            }
            //NOTE: autocomplete-rajapinta tukee vain suomea ja englantia
            axios.get(`keywords/autocompleteSkillWords/${langCode}/${this.autocompleteSkillWords}`).then((r) => {
               this.autoCompleteData = r.data.data;               
            });
         } else {
            this.autoCompleteData = [];
         }
      },
      occupationSearchText(){
         if(this.occupationSearchText+""!==""){
            this.showOccupationDropdownDiv();
            this.showAllOccupations=false;
         }
      },
      ictSkillsSearchText(){
         if(this.ictSkillsSearchText+""!==""){
            this.showIctSkillsDropdownDiv();
            this.showAllIctSkills=false;
         }
      }

      
	},   
});
